import { ITreeCollection } from "@dhx/ts-data";
import { IGrid } from "@dhx/ts-grid";

export { IGridConfig as ITreeGridConfig } from "@dhx/ts-grid";
export { GridEvents as TreeGridEvents } from "@dhx/ts-grid";


export interface ITreeGridCollection extends ITreeCollection {
	getMaxLevel(): any;
}

export interface ITreeGrid extends IGrid {
	scrollTo(row: string, col: string): void;
	expand(id: string): void;
	collapse(id: string): void;
	expandAll(): void;
	collapseAll(): void;
}